import { OptimizationDto } from "#modules/optimizations/infra/computeOptimizations.api";

export type OptimizationFilter = "all" | "nesting" | "processes";

export const isNestingOptimization = (optimization: OptimizationDto) =>
  optimization.sheetNestingOptimizationMetadata !== null;

export const isProcessOptimization = (optimization: OptimizationDto) =>
  Boolean(optimization.machineTimesOptimizationMetadata?.companyMachine.machine.industrialProcess);

export const matchesOptimizationFilter = (
  optimization: OptimizationDto,
  filter: OptimizationFilter,
) => {
  if (optimization.deletedAt) {
    return false;
  }

  if (filter === "nesting") {
    return isNestingOptimization(optimization);
  }

  if (filter === "processes") {
    return isProcessOptimization(optimization);
  }

  return true;
};
